import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import OperationsCloud from "@/pages/OperationsCloud";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/products/operations-cloud" element={<OperationsCloud />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
